import axios from 'axios';
import { urlApiAsesoria } from '../Config/baseUrl';
import { ICambiarClave, IForgetPassword } from '../Interfaces/IForgetPassword';

// const baseURL = baseUrlProduction;

const config = {
  headers: {
    'Content-Type': 'application/json',
  },
};

export const obtenerCorreoOlvidoContraseña = (data: IForgetPassword) => {
  return axios.post(
    urlApiAsesoria + 'retoAsesoria/obtenerCorreoyRecuperar',
    data,
    config,
  );
};

export const obtenerCorreo = (data: IForgetPassword) => {
  return axios.post(urlApiAsesoria + 'retoAsesoria/obtenerCorreo', data, config);
};

export const cambiarContraseña = (data: ICambiarClave) => {
  return axios.post(urlApiAsesoria + 'retoAsesoria/cambiarClave', data, config);
};
